import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '@ownyou/ui-design-system';
const variantClasses = {
    elevated: 'bg-white shadow-md',
    outlined: 'bg-white border border-neutral-200',
    filled: 'bg-neutral-50',
};
const paddingClasses = {
    none: '',
    sm: 'p-3',
    md: 'p-4',
    lg: 'p-6',
};
/**
 * Card component for grouping content with visual separation.
 * Supports elevation, outline, and filled styles with optional interactivity.
 */
export function Card({ variant = 'elevated', interactive = false, selected = false, padding = 'md', children, className, onClick, onKeyDown, ...rest }) {
    const handleKeyDown = (e) => {
        if (interactive && (e.key === 'Enter' || e.key === ' ')) {
            e.preventDefault();
            onClick?.(e);
        }
        onKeyDown?.(e);
    };
    return (_jsx("div", { className: cn('rounded-xl overflow-hidden transition-all', variantClasses[variant], paddingClasses[padding], interactive && 'cursor-pointer hover:shadow-lg active:scale-[0.98]', selected && 'ring-2 ring-brand-500', className), ...(interactive
            ? { role: 'button', tabIndex: 0 }
            : {}), onClick: onClick, onKeyDown: handleKeyDown, ...rest, children: children }));
}
